import CreateMapProcess from "../createmap/CreateMapProcess";
import { ListView } from "../common/ListView";
import styles from "./UserGuide.module.css";
import { ReactElement } from "react";

export interface UserGuideProps {
    num: number;
    tit1: string;
    tit2: string;
    src: string;
    list: ReactElement;
}

/**
 * @author sukim91
 * @date 2022-09-28 00:35:13
 * @remark 사용자 가이드 컴포넌트
 * @param props UserGuideProps
 * @props UserGuideProps
 *      num(required): 영상의 순서
 *      tit1(required): 영상 제목
 *      tit2(required): 영상 제목 설명
 *      src(required): 영상 url
 *      list(required): 영상 하단 상세 설명 element
 * @returns <div>
 */
export function UserGuide() {
    const UserGuideMakeMapItem = [
        {
            num: 1,
            tit1: "데이터 입력",
            tit2: "주소 정보가 포함된 파일을 DRAG&DROP으로 편리하게 입력할 수 있습니다.",
            src: "https://www.youtube.com/embed/oGd7Fr8qrtk?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: (
                <>
                    주소정보가 포함된 엑셀 및 CSV 데이터를 드래그하여 데이터를 입력해 보세요.
                    <br /> AI가 자동으로 주소필드를 선택해줍니다.
                </>
            ),
        },
        {
            num: 2,
            tit1: "지도 옵션설정",
            tit2: "마커설정, 장소정보설정, 배경지도설정을 사용하여 나만의 지도를 제작해 보세요.",
            src: "https://www.youtube.com/embed/zkBj1tv7YJc?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: (
                <>
                    마커 설정에서는 3개의 모양과 16가지의 색상의 다양한 마커를 사용할 수 있습니다.
                    <br /> 장소정보설정에서는 대표이미지와 보여줄 데이터를 미리 보면서 설정할 수 있습니다.
                    <br /> 또한 배경지도설정에서는 바로E맵, OSM(Open Street Map)을 지원합니다.
                    <br /> 🎨 언제든지 이전단계로 돌아가서 옵션을 다시 설정할 수 있습니다 !
                </>
            ),
        },
        {
            num: 3,
            tit1: "지도제작",
            tit2: "지도 옵션설정에서 선택한 설정으로 나만의 지도를 제작해 보세요. 그리고 키워드를 추가해보세요.",
            src: "https://www.youtube.com/embed/pB7v3Wv6-zU?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: (
                <>
                    완료버튼을 누름과 동시에 주소데이터를 지도위에 보여주는 작업을 진행합니다. <br /> 비공개지도는 로그인 유저만 제작가능합니다.
                </>
            ),
        },
        {
            num: 4,
            tit1: "마이지도 사용하기",
            tit2: "제작된 지도를 이메일로 전송하여 나만의 지도를 확인하세요.",
            src: "https://www.youtube.com/embed/p5yxxq_jvmM?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: (
                <>
                    이메일로 전송한 지도를 확인할 수 있습니다. &#91;지도확인&#93; 버튼을 클릭하여 브라우저에서 지도를 확인할 수 있고, 블로그나
                    웹사이트에 삽입할 수 있습니다.
                </>
            ),
        },
    ];

    const UserGuideUseMapItem = [
        {
            num: 1,
            tit1: "지도 목록·이용",
            tit2: "추천지도와 공개지도를 확인하고, 지도를 이용해보세요.",
            src: "https://www.youtube.com/embed/Kl1WfgUXrng?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: <>마음에 드는 지도를 즐겨찾기하고, 특정 장소를 검색하고, 도움돼는 장소에 엄지를 날려주고, 새로운 장소를 추가할 수 있습니다.</>,
        },
        {
            num: 2,
            tit1: "계산·분석 도구",
            tit2: "행정경계, 단계구분도, 차트, 시간별이동거리 등 다양한 분석을 이용해보세요.",
            src: "https://www.youtube.com/embed/KRDCOfG7pck?autoplay=0&loop=1&rel=0&mute=1&vq=hd1080",
            list: (
                <>
                    기본적인 계산도구와 히트맵, 버블맵 뿐 아니라 다양한 분석도구를 제공합니다.
                    <br /> 특정 이동수단으로 접근가능한 구역을 확인하거나, 다른 지도를 오버랩 해서 보다 깊은 인사이트를 가져가세요.
                </>
            ),
        },
    ];

    const YoutubeIframe = (props: { src: string }) => {
        return (
            <iframe
                className={styles.video}
                width="990px"
                height="472.5px"
                src={props.src}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
            ></iframe>
        );
    };

    const renderItem = (props: UserGuideProps) => {
        return (
            <div className={styles.card_container}>
                <div className={styles.card_contents_wrapper}>
                    <div className={styles.card_tit}>
                        <div className={styles.video_tit_container}>
                            <span className={styles.num}>{props.num}</span>
                            <span className={styles.video_tit1} dangerouslySetInnerHTML={{ __html: props.tit1 }}></span>
                        </div>
                        <span className={styles.video_tit2}>{props.tit2}</span>
                    </div>
                    <div className={styles.card_sub}>
                        <YoutubeIframe src={props.src}></YoutubeIframe>
                        <span className={styles.video_desc}>{props.list}</span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={styles.container} id={"user_guide"}>
            <div className={styles.contents_wrapper}>
                <div className={styles.contents_container}>
                    <span className={styles.tit}>지도만들기 | 모두의지도 사용 가이드</span>

                    <span className={styles.sub}>아래 순서대로 진행하세요.</span>
                    <CreateMapProcess></CreateMapProcess>
                </div>
                <ListView data={UserGuideMakeMapItem} renderItem={renderItem} />
                <div className={styles.contents_container}>
                    <span className={styles.tit}>지도이용 | 모두의지도 사용 가이드</span>
                    <span className={styles.sub}>지도 사용법과 각종 도구를 영상으로 확인하세요</span>
                </div>
                <ListView data={UserGuideUseMapItem} renderItem={renderItem} />
            </div>
        </div>
    );
}

export default UserGuide;
